import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import FormLabel from '@mui/material/FormLabel';
import React from 'react';

import Text from '../../../components/Text';
import { FBLabelFontSize, FBLabelProps } from '../../types/common';

const FBLabel: React.FC<FBLabelProps> = ({
  label,
  error,
  fontSize = 'md',
  loading,
  ...boxProps
}) => (
  <FormLabel component="legend" error={error}>
    <Box
      mb={0.5}
      fontSize={FBLabelFontSize[fontSize] ?? '1rem'} // {FBLabelFontSize[fontSize]?.fontSize ?? '1rem'}
      fontWeight={300}
      display="flex"
      alignItems="center"
      {...boxProps}
    >
      <Text message={label as string} />
      {loading && (
        <Box ml={1} component="span">
          <CircularProgress size={15} />
        </Box>
      )}
    </Box>
  </FormLabel>
);

export default FBLabel;
